import { AlignLeft, Cake, CheckSquare, Circle, Clock, Calendar, Hash, IdCard, Mail, MapPin, Phone, Type, Upload } from 'lucide-react';
import masks from 'helpers/masks';

// Fonte única pros tipos de campo adicional: ícone, descrição em linguagem
// simples e um exemplo pronto — usados no select de criação, no preview ao
// vivo e no card de leitura em "Adicionais". `mask` fica de fora quando o
// tipo não precisa (ex: texto livre).
const customFieldsTypes = [
    {
        value: 'text',
        label: 'Campo de texto curto',
        icon: Type,
        description: 'Resposta curta, em uma linha. Bom para nome, empresa ou cargo.',
        example: 'Ex: João da Silva',
    },
    {
        value: 'textarea',
        label: 'Campo de texto longo',
        icon: AlignLeft,
        description: 'Resposta mais longa, em várias linhas. Bom para observações ou restrição alimentar.',
        example: 'Ex: Sou vegetariano e tenho alergia a amendoim.',
    },
    {
        value: 'numeric',
        label: 'Campo númerico',
        icon: Hash,
        description: 'Aceita só números. Bom para idade, tamanho ou quantidade.',
        example: 'Ex: 42',
    },
    {
        value: 'email',
        label: 'E-mail',
        icon: Mail,
        description: 'Endereço de e-mail, com o teclado certo no celular do comprador.',
        example: 'Ex: nome@email.com',
    },
    {
        value: 'phone',
        label: 'Telefone',
        icon: Phone,
        mask: masks.phone,
        description: 'Número de telefone, já formatado enquanto o comprador digita.',
        example: 'Ex: (11) 91234-5678',
    },
    {
        value: 'cpf',
        label: 'CPF',
        icon: IdCard,
        mask: masks.cpf,
        description: 'Documento de pessoa física, já formatado enquanto o comprador digita.',
        example: 'Ex: 123.456.789-00',
    },
    {
        value: 'cnpj',
        label: 'CNPJ',
        icon: IdCard,
        mask: masks.cnpj,
        description: 'Documento de empresa, já formatado enquanto o comprador digita.',
        example: 'Ex: 12.345.678/0001-90',
    },
    {
        value: 'cep',
        label: 'CEP',
        icon: MapPin,
        mask: masks.cep,
        description: 'CEP do endereço do comprador, já formatado.',
        example: 'Ex: 01310-100',
    },
    {
        value: 'birth_date',
        label: 'Data de nascimento',
        icon: Cake,
        description: 'Um calendário pra escolher a data de nascimento do comprador.',
        example: '',
    },
    {
        value: 'date',
        label: 'Data',
        icon: Calendar,
        description: 'Um calendário para escolher qualquer outra data.',
        example: '',
    },
    {
        value: 'time',
        label: 'Hora',
        icon: Clock,
        description: 'Um seletor de horário, como horário previsto de chegada.',
        example: '',
    },
    {
        value: 'radio',
        label: 'Seleção única',
        icon: Circle,
        description: 'O comprador escolhe uma única opção entre as que você criar.',
        example: 'Ex: P, M, G, GG',
    },
    {
        value: 'checkbox',
        label: 'Seleção múltipla',
        icon: CheckSquare,
        description: 'O comprador pode marcar mais de uma opção ao mesmo tempo.',
        example: 'Ex: Vegetariano, Sem glúten, Vegano',
    },
    {
        value: 'upload',
        label: 'Arquivo',
        icon: Upload,
        description: 'O comprador anexa um arquivo, como comprovante ou documento.',
        example: 'comprovante.pdf',
    },
];


export default customFieldsTypes
